export const getDifferenceInSeconds = (startTime: number): number => {
  if (!startTime) return startTime;
  return Math.floor((Date.now() - startTime) / 1000);
};
